<template>
	<el-tabs v-model="activeName">
		<el-tab-pane label="全部" name="all"></el-tab-pane>
		<el-tab-pane label="待付款订单" name="waitpay"></el-tab-pane>
		<el-tab-pane label="待处理订单" name="due"></el-tab-pane>
		<el-tab-pane label="预留单" name="reserve"></el-tab-pane>
		<el-tab-pane label="预售单" name="presale"></el-tab-pane>
		<el-tab-pane label="前台未付款单" name="front"></el-tab-pane>
		<el-tab-pane label="已取消" name="canceled"></el-tab-pane>
		<el-tab-pane label="新建订单" name="build"></el-tab-pane>
	</el-tabs>
</template>

<script>
export default {
	data() {
		return {
			fakeTabs: {
				all: { name: "Order-Index" },
				due: { name: "Order-IndexDue" },
				build: { name: "Order-Create" },
				front: { name: "Order-Front" },
				waitpay: { name: "Order-WaitPay" },
				reserve: { name: "Order-Reserve" },
				canceled: { name: "Order-Canceled" },
				presale: { name: "Order-PreSale" },
			},
		};
	},
	mounted() {
		this.refreshRoute();
	},

	methods: {
		refreshRoute(tab = null) {
			if (!tab && this.$route.params.tab) {
				this.activeName = this.$route.params.tab;
			} else if (tab) {
				this.activeName = tab;
			}
		},
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: {
			handler(val) {
				if (val && val.params.tab != this.activeName) {
					this.refreshRoute();
				}
			},
			immediate: true,
			deep: true,
		},
		activeName(val, old) {
			if (val != old && this.$route.params.tab != val) {
				if (this.fakeTabs[val]) {
					this.$router.push(this.fakeTabs[val]);
				} else {
					let params = Object.assign({}, this.$route.params);
					params.tab = val;
					this.$router.replace({
						name: this.$route.name,
						params: params,
					});
				}
			}
		},
	},
	name: "DueTabs",

	computed: {
		activeName: {
			get: function() {
				return this.value;
			},
			set: function(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", newValue);
			},
		},
	},
	props: {
		value: {
			type: [Number, String],
			default: null,
		},
	},
};
</script>